import React, { memo } from 'react';
import cx from 'classnames';
import AvatarButton from '@components/@core/AvatarButton';
import Icon from '@components/@core/Icon';
import Thumbnail from '@components/@core/Thumbnail';
import { getImageURL } from '~/services/util';

const Card = ({ avatar, date, images, index, stats, text, title, user, company, appId, onClick, onOpen }) =>
    index < 5 ? (
        <div className="card cursor-pointer" onClick={onClick}>
            <div className="d-h-between">
                <div className="d-flex ai-center">
                    <AvatarButton
                        className="blog-card-avatar"
                        avatar={avatar}
                        username={`${user?.first_name} ${user?.last_name}`}
                        companyName={company?.name ?? user?.profile?.company}
                        slug={user?.entity?.slug}
                    />
                </div>
                <span className="dsl-b12">{date}</span>
            </div>
            <p className="dsl-b18 bold mt-4">{title}</p>
            {images && <Thumbnail source={getImageURL(images)} size="responsive" />}
            <div className="dsl-b16 text-400 mt-4">
                <span className="short-text">
                    {text && <span dangerouslySetInnerHTML={{ __html: `${text.substring(0, 180)}...` }} />}
                    <span className="dsl-read-more">Read more</span>
                </span>
            </div>
            <div className="d-flex py-3">
                <Icon name="far fa-eye me-2 text-500" size={12} color="#969faa" />
                <span className="dsl-d12">{stats?.views || 0}</span>
                <Icon name="fas fa-thumbs-up ms-4 me-2 text-500" size={12} color={stats?.liked && appId && stats?.liked[appId] ? '#376caf' : '#969faa'} />
                <span className={cx('dsl-d12', stats?.liked && appId && stats?.liked[appId] && 'dsl-p12 text-500')}>{stats?.likes || 0}</span>
                <Icon name="far fa-comment ms-4 me-2 text-500" size={12} color="#969faa" />
                <span className="dsl-d12">{stats?.comments || 0}</span>
            </div>
            {/*<Button className="ml-auto my-2" name="SEE ALL" type="link" onClick={onClick} />*/}
        </div>
    ) : (
        <div className="d-flex ssm-column cursor-pointer small-card" onClick={onClick}>
            <div className="d-h-center d-flex-2 me-sm-3 blog-sm">{images && <Thumbnail source={getImageURL(images)} size="regular" />}</div>
            <div className="blog-sm-inner d-flex-3">
                <div className="overflow-hidden blog-detail h75">
                    <p className="dsl-b14 bold mb-2">{title}</p>
                    <p className="dsl-b14 text-400">{text && <span dangerouslySetInnerHTML={{ __html: `${text.substring(0, 180)}...` }} />}</p>
                </div>
                <div className="d-flex ai-center h25">
                    <Icon name="far fa-eye me-2 text-500" size={12} color="#969faa" />
                    <span className="dsl-d12">{stats?.views || 0}</span>
                    <Icon name="fas fa-thumbs-up ms-4 me-2 text-500" size={12} color={stats?.liked && appId && stats?.liked[appId] ? '#376caf' : '#969faa'} />
                    <span className={cx('dsl-d12', stats?.liked && appId && stats?.liked[appId] && 'dsl-p12 text-500')}>{stats?.likes || 0}</span>
                    <Icon name="far fa-comment ms-4 me-2 text-500" size={12} color="#969faa" />
                    <span className="dsl-d12">{stats?.comments || 0}</span>
                </div>
            </div>
        </div>
    );
export default memo(Card);
